module.exports = __webpack_public_path__ + "static/media/location-direction-restaurant.7aeaebe9.svg";